import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resetPassword, storeSession } from '../../api/backend';
import './AuthModal.css';

// Landing page for the password-reset email link:
// /reset-password?token=...&email=...
// On success the backend logs the user in; we store the session and send them
// straight to the game.
const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const email = useMemo(() => searchParams.get('email') || '', [searchParams]);

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const linkBroken = !token || !email;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setSubmitting(true);
    try {
      const data = await resetPassword(email, token, password);
      storeSession({ token: data.token, email: data.email });
      // Full reload so the app restores the fresh session everywhere.
      window.location.href = '/game';
    } catch (err) {
      setError(err.message || 'Could not reset the password. Please request a new link.');
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-modal">
      <div className="auth-modal__card" role="dialog" aria-label="Reset password">
        <h2 className="auth-modal__title">Reset Password</h2>

        {linkBroken ? (
          <p className="auth-modal__reason">
            This reset link looks incomplete. Please open the link from your email
            again, or request a new one from the login screen.
          </p>
        ) : (
          <>
            <p className="auth-modal__reason">
              Set a new password for <b>{email}</b>. This one password works on
              satoshiadvance.com and all mini games.
            </p>

            <form className="auth-modal__form" method="post" onSubmit={handleSubmit}>
              <label className="auth-modal__label" htmlFor="reset-password">New Password</label>
              <input
                id="reset-password"
                name="password"
                className="auth-modal__input"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 6 characters"
              />

              <label className="auth-modal__label" htmlFor="reset-confirm">Confirm Password</label>
              <input
                id="reset-confirm"
                name="confirm"
                className="auth-modal__input"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Repeat the new password"
              />

              {error && <div className="auth-modal__error">{error}</div>}

              <button type="submit" className="auth-modal__submit" disabled={submitting}>
                {submitting ? 'Please wait…' : 'Set Password & Play'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
